import React from 'react';
import {useLastValue} from '#lib/hooks/use-last-value.js';

export default function useDocumentEvent(type, listener, options) {
    let listenerRef = useLastValue(listener);

    React.useEffect(() => {
        function handler(event) {
            listenerRef.current(event);
        }

        document.addEventListener(type, handler, options);
        return () => document.removeEventListener(type, handler, options);
    }, [type, options, listenerRef]);
}
